import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';;
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'delivery-details',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "DATA":[
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        colseDialogFun:null,
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'proforma-invoice-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'deliveryDetails/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
    }
}
const state = () => ({
    deliveryDetails: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.deliveryDetails.pageConfig,
    getPageConfigTree: state => state.deliveryDetails.pageConfigTree,
    getPageKey:state => state.deliveryDetails.pageKey,
    getPushDataDialog:state => state.deliveryDetails.dialogPage,
    getPushDataPageKey:state => state.deliveryDetails.dialogPage.pageKey,
}
const mutations ={
    setRestPageFun(state, data){
        state.deliveryDetails.resetPage = data;
    },
    setLoading(state, data){
        state.deliveryDetails.loading = data;
        if(isNotEmpty(state.deliveryDetails.pageConfig)){
            Object.keys(state.deliveryDetails.pageConfig).forEach((key,index)=>{
                state.deliveryDetails.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.deliveryDetails.pageConfig = data.pageConfig;
        state.deliveryDetails.pageConfigTree = data.allArrData;
        state.deliveryDetails.pageKey = getRandomString();
        if(isNotEmpty(state.deliveryDetails.pageConfig)){
            Object.keys(state.deliveryDetails.pageConfig).forEach((key,index)=>{
                state.deliveryDetails.pageConfig[key].height = state.deliveryDetails.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.deliveryDetails.dialogPage.pageConfig = data.pageConfig;
        state.deliveryDetails.dialogPage.pageConfigTree = data.allArrData;
        state.deliveryDetails.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.deliveryDetails.dialogPage.pageConfig)){
            Object.keys(state.deliveryDetails.dialogPage.pageConfig).forEach((key,index)=>{
                state.deliveryDetails.dialogPage.pageConfig[key].height = state.deliveryDetails.height
            })
        }
    },
    setPushDialogList(state, data){
        state.deliveryDetails.dialogPage.pageConfig[data.obj].data = data.data;
        state.deliveryDetails.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        state.deliveryDetails.pageConfig[data.obj].data = data.data;
        state.deliveryDetails.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.deliveryDetails.height = (data) + 'px';
        if(isNotEmpty(state.deliveryDetails.pageConfig)){
            Object.keys(state.deliveryDetails.pageConfig).forEach((key,index)=>{
                state.deliveryDetails.pageConfig[key].height = state.deliveryDetails.height;
            })
        }
        state.deliveryDetails.dialogPage.height = (data) + 'px';
        if(isNotEmpty(state.deliveryDetails.dialogPage.pageConfig)){
            Object.keys(state.deliveryDetails.dialogPage.pageConfig).forEach((key,index)=>{
                state.deliveryDetails.dialogPage.pageConfig[key].height = state.deliveryDetails.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.deliveryDetails.pageConfig,pageConfigTree:state.deliveryDetails.pageConfigTree});
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.deliveryDetails.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__hu", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.deliveryDetails.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.deliveryDetails.tableName,top_tools:state.deliveryDetails.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.deliveryDetails.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.deliveryDetails.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__hu_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
